import { Voucher_Source_Type, Voucher_State, Vouchers_Sort_By } from '@occc/graphql';
import {
  useFilterDateParams,
  useFilterParams,
} from '@occc-app/routes/Member/MemberDetailsPage/utils';
import { DateRange } from '@occc-app/routes/Member/MemberDetailsPage/components/OffersAndVouchers/Vouchers/types';
import { useSortingParams as useSortingParamsImported } from '@occc-app/hooks/useSortingParams';

import {
  VOUCHERS_AFTER_PARAM,
  VOUCHERS_BEFORE_PARAM,
  VOUCHERS_CREATED_AT_END_PARAM,
  VOUCHERS_CREATED_AT_RANGE_PARAM,
  VOUCHERS_CREATED_AT_START_PARAM,
  VOUCHERS_EXPIRE_AT_END_PARAM,
  VOUCHERS_EXPIRE_AT_RANGE_PARAM,
  VOUCHERS_EXPIRE_AT_START_PARAM,
  VOUCHERS_SORT_DIRECTION_PARAM,
  VOUCHERS_SORT_FIELD_PARAM,
  VOUCHERS_SOURCE_TYPE_PARAM,
  VOUCHERS_STATE_PARAM,
} from '../../../constants';

export const useSourceTypeFilter = () => {
  return useFilterParams<Voucher_Source_Type>(
    Voucher_Source_Type,
    VOUCHERS_SOURCE_TYPE_PARAM,
    VOUCHERS_BEFORE_PARAM,
    VOUCHERS_AFTER_PARAM,
  );
};

export const useStateFilter = () => {
  return useFilterParams<Voucher_State>(
    Voucher_State,
    VOUCHERS_STATE_PARAM,
    VOUCHERS_BEFORE_PARAM,
    VOUCHERS_AFTER_PARAM,
  );
};

export const useCreatedAtRangeFilter = () => {
  return useFilterParams<DateRange>(
    DateRange,
    VOUCHERS_CREATED_AT_RANGE_PARAM,
    VOUCHERS_BEFORE_PARAM,
    VOUCHERS_AFTER_PARAM,
  );
};

export const useExpireAtRangeFilter = () => {
  return useFilterParams<DateRange>(
    DateRange,
    VOUCHERS_EXPIRE_AT_RANGE_PARAM,
    VOUCHERS_BEFORE_PARAM,
    VOUCHERS_AFTER_PARAM,
  );
};

export const useCreatedAtStartFilter = () => {
  return useFilterDateParams(
    VOUCHERS_CREATED_AT_START_PARAM,
    VOUCHERS_BEFORE_PARAM,
    VOUCHERS_AFTER_PARAM,
  );
};

export const useCreatedAtEndFilter = () => {
  return useFilterDateParams(
    VOUCHERS_CREATED_AT_END_PARAM,
    VOUCHERS_BEFORE_PARAM,
    VOUCHERS_AFTER_PARAM,
  );
};

export const useExpireAtStartFilter = () => {
  return useFilterDateParams(
    VOUCHERS_EXPIRE_AT_START_PARAM,
    VOUCHERS_BEFORE_PARAM,
    VOUCHERS_AFTER_PARAM,
  );
};

export const useExpireAtEndFilter = () => {
  return useFilterDateParams(
    VOUCHERS_EXPIRE_AT_END_PARAM,
    VOUCHERS_BEFORE_PARAM,
    VOUCHERS_AFTER_PARAM,
  );
};

export const useSortingParams = () => {
  return useSortingParamsImported<Vouchers_Sort_By>({
    sortFieldParamName: VOUCHERS_SORT_FIELD_PARAM,
    sortDirectionParamName: VOUCHERS_SORT_DIRECTION_PARAM,
    beforeParamName: VOUCHERS_BEFORE_PARAM,
    afterParamName: VOUCHERS_AFTER_PARAM,
    initialValues: {
      field: Vouchers_Sort_By.CreatedAt,
      direction: 'desc',
    },
  });
};
